import instance from '@/plugins/axios'
import type { DashboardDTO } from '@/modules/reservations/models/dashboard'
import type { ResponseResult } from '@/core/models/api-responses'

async function getAll(queryString = ''): Promise<ResponseResult<DashboardDTO>> {
  const url = queryString ? `/Dashboards?${queryString}` : '/Dashboards'
  const res = await instance.get<ResponseResult<DashboardDTO>>(url)
  return res.data
}
export default {
  getAll,
}